import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import KasaApp from './KasaApp';
import './styles.css';

// kasa.* alt alan adinda dogrudan Kasa ekrani; digerlerinde normal site.
const isKasa = typeof window !== 'undefined' && window.location.hostname.startsWith('kasa.');
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isKasa ? (
      <KasaApp />
    ) : (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )}
  </StrictMode>,
);

// PWA service worker — sadece production'da (dev'de HMR'ı bozmasın).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
